import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { useArticles } from '../../hooks/useAirtableArticles'


const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const BlogSidebar = (props) => {
    const { articles } = useArticles(3, true);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();
    
    return (
        <div className={`col col-lg-4 col-12 ${props.blLeft}`}>
            <div className="blog-sidebar">
                <div className="widget about-widget">
                    <div className="img-holder">
                        <img src="/dr-eugene-pereira-picture.jpg" alt="Dr. Eugene Pereira" />
                    </div>
                    <h4>Dr. Eugene G. Pereira, MD</h4>
                    <p>Board-Certified Pain Management Specialist with over 20 years of experience in regenerative medicine and interventional pain management.</p>
                    <div className="social">
                        <ul className="clearfix">
                            <li><Link onClick={ClickHandler} to="/contact"><i className="ti-facebook"></i></Link></li>
                            <li><Link onClick={ClickHandler} to="/contact"><i className="ti-twitter-alt"></i></Link></li>
                            <li><Link onClick={ClickHandler} to="/contact"><i className="ti-linkedin"></i></Link></li>
                            <li><Link onClick={ClickHandler} to="/contact"><i className="ti-instagram"></i></Link></li>
                        </ul>
                    </div>
                </div>
                <div className="widget search-widget">
                    <h3>Search Articles</h3>
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        if (searchTerm.trim()) {
                            navigate(`/blog?search=${encodeURIComponent(searchTerm.trim())}`);
                            setSearchTerm('');
                        }
                    }}>
                        <div>
                            <input 
                                type="text" 
                                className="form-control" 
                                placeholder="Search articles..." 
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <button type="submit"><i className="ti-search"></i></button>
                        </div>
                    </form>
                </div>
                {articles && articles.length > 0 && (
                    <div className="widget recent-post-widget">
                        <h3>Recent Articles</h3>
                        <ul>
                            {articles.map((article) => (
                                <li key={article.id} style={{marginBottom: '25px'}}>
                                    <Link onClick={ClickHandler} to={`/blog/${article.slug}`}>
                                        {article.title}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </div>
    )

}

export default BlogSidebar;
